import React from 'react';
import styled from 'styled-components';
import { Button } from 'react-bootstrap';
import {Link, useParams} from 'react-router-dom';
import Preview from './Preview';

function Resources() {
  const { partnerId } = useParams();


  return (
    <ContentWrapper>
    <Title>Click button to create new blog</Title>    
    {/* create new blog button */}      
      <Link to={`/${partnerId}/resources/create`}>
        <Button>Create a new blog</Button>
      </Link>
    <Preview/>
    </ContentWrapper> 
  );
}

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: auto;
      @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
`;

const Title = styled.h3`
  text-align: center;
  padding: 5px 0;
`;

export default Resources;
